/* global process */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { attemptAppRedirect } from "./deeplinking";
import * as Sentry from "@sentry/react";

// Only initialize Sentry in non-local environments
if (process.env.NODE_ENV === "production") {
  const environment = process.env.REACT_APP_ENV || "production";
  Sentry.init({
    dsn: "https://4be6acbef19980a4d4855af0df837615@o4507151305801728.ingest.us.sentry.io/4509370792280064",
    environment: environment,
    // Setting this option to true will send default PII data to Sentry
    sendDefaultPii: true,
    // Only send errors in actual production/staging environments
    enabled: environment !== "local",
    // Adjust sample rate if needed (1.0 = capture 100% of transactions)
    tracesSampleRate: environment === "production" ? 0.2 : 0.5,
  });

  console.log(`Sentry initialized in ${environment} environment`);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Call when page loads
window.addEventListener("load", attemptAppRedirect);
